// People are shown by their preferred name everywhere except flights, which must
// match the legal name on the booking. A one-word preferred name ("Jess") keeps the
// surname from the full name so staff lists stay unambiguous ("Jess Morgan").
const clean = value => (typeof value === "string" ? value.trim().replace(/\s+/g, " ") : "");

export function displayName(user, fallback = "") {
  const preferred = clean(user?.preferred_name), full = clean(user?.full_name);
  if (preferred) {
    const parts = full.split(" ");
    return !preferred.includes(" ") && parts.length > 1 ? `${preferred} ${parts[parts.length - 1]}` : preferred;
  }
  return full || clean(user?.email) || fallback;
}

// Greetings and other informal, first-name-only text.
export function firstName(user, fallback = "") {
  return clean(user?.preferred_name).split(" ")[0] || clean(user?.full_name).split(" ")[0] || fallback;
}

// Flights and travel documents only.
export function legalName(user, fallback = "") {
  return clean(user?.full_name) || clean(user?.email) || fallback;
}
